import React, { useState, useRef, useEffect } from 'react';
import { BsBell, BsSearch, BsGear, BsSun, BsMoon, BsChevronDown, BsFullscreen, BsFullscreenExit } from 'react-icons/bs';
import { useTheme } from '../../context/ThemeContext';
import { useTranslation } from 'react-i18next';
import './styles.css';

const languages = [
  { code: 'tr', name: 'TR' },
  { code: 'en', name: 'EN' }
];

const Topbar = () => {
  const { theme, toggleTheme } = useTheme();
  const { t, i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState(i18n.language || 'tr');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const getCurrentLanguage = () => {
    return languages.find(lang => lang.code === currentLang);
  };

  const handleLanguageChange = (langCode) => {
    setCurrentLang(langCode);
    i18n.changeLanguage(langCode);
    setIsDropdownOpen(false);
  };

  return (
    <div className="topbar">
      <div className="topbar-left">
        <div className="search-box">
          <BsSearch className="search-icon" />
          <input type="text" placeholder={t('common.search')} />
        </div>
      </div>

      <div className="topbar-right">
        <div className="language-selector" ref={dropdownRef}>
          <button 
            className="language-btn"
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          >
            <img 
              src={`https://flagcdn.com/w40/${currentLang === 'en' ? 'gb' : currentLang}.png`}
              alt={getCurrentLanguage()?.name}
            />
            <span>{getCurrentLanguage()?.name}</span>
            <BsChevronDown />
          </button>

          <div className={`language-dropdown ${isDropdownOpen ? 'show' : ''}`}>
            {languages.map((lang) => (
              <div
                key={lang.code}
                className={`language-option ${currentLang === lang.code ? 'active' : ''}`}
                onClick={() => handleLanguageChange(lang.code)}
              >
                <img 
                  src={`https://flagcdn.com/w40/${lang.code === 'en' ? 'gb' : lang.code}.png`}
                  alt={lang.name}
                />
                <span>{lang.name}</span>
              </div>
            ))}
          </div>
        </div>

        <button 
          className="theme-toggle-btn" 
          onClick={toggleTheme}
          title={theme === 'light' ? t('common.darkTheme') : t('common.lightTheme')}
        >
          {theme === 'light' ? <BsMoon /> : <BsSun />}
        </button>
        <div className="notification-btn" title={t('common.notifications')}>
          <BsBell />
          <span className="notification-badge">3</span>
        </div>
        <div className="settings-btn" title={t('common.settings')}>
          <BsGear />
        </div>
      </div>
    </div>
  );
};

export default Topbar; 